<!-- =========================================================================================
  File Name: Sliders.vue
  Description: Sliders' list
  ----------------------------------------------------------------------------------------
  Item Name: FastWay - Sliders list for management
  Author: Oscar Ramírez O.
  Author URL: https://acentoNET.com
========================================================================================== -->

<template>

  <div>
    <vs-button radius color="danger" type="filled" icon-pack="feather" icon="icon-plus" class="add-button" :to="{name: 'slider', params: { id: 0 }}"/>

    <div class="p-6 flex flex-col">
      <div
        class="vx-card flex w-full mb-4 bg-contain bg-no-repeat bg-center cursor-pointer p-3"
        :style="{ 'background-image': `url(${image(item)})`}"
        style="background-repeat: no-repeat; background-position: center center; height: 350px;"
        @click="edit(item)"
        v-for="item in data" :key="item.id">
        <h2>{{ item.sequence }}</h2>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    data() {
      return {
        loaded: false
      }
    },
    computed: {
      imagesURL() {
        return this.$store.getters['getParameter']('images').baseURL;
      },
      data() {
        return [...this.$store.getters.slidersList].sort(function (a, b) {
          let ret = 1;
          if (a.sequence < b.sequence) {
            ret = -1;
          }
          return ret;
        });
      }
    },
    methods: {
      image(item) {
        return [this.imagesURL, '/slider%2F', item.imageURL.split('.')[0], '@535.', item.imageURL.split('.')[1], '?alt=media'].join('');
      },
      edit(item) {
        this.$router.push(`/home/slider/${item.id}`).catch(() => { });
      }
    }
  }

</script>

<style lang="scss">
  .add-button {
    position: fixed;
    bottom: 5%;
    right: 29px;
    z-index: 51000;
    box-shadow: 0 1px 20px 1px rgb(251, 67, 79);
  }
</style>
